import qs from 'qs'
import { Analytics } from '@ycos/analytics'

export const siteMerchCtaTrack = ({ item, layoutVariantAllowlist, layoutVariantBlocklist }) => {

    // Handle allowlist/blocklist filtering
    if (layoutVariantAllowlist && !layoutVariantAllowlist.includes(item.layoutVariant)) {
        return {};
    }
    if (layoutVariantBlocklist && layoutVariantBlocklist.includes(item.layoutVariant)) {
        return {};
    }

    // Proceed with the rest of the logic if:
    // - `layoutVariantAllowlist`, `layoutVariantBlocklist` NOT provided, OR
    // - `item.layoutVariant` matches `layoutVariantAllowlist`
    // - `item.layoutVariant` not matches `layoutVariantBlocklist`

    if (!item.href) return {}
    const { href } = item
    const hrefContainsAnalyticsString = href && href.indexOf('cm_sp=') !== -1
    if (hrefContainsAnalyticsString) {
        const siteMerchandising = getSiteMerchObject(item)
        if (!siteMerchandising) {
            return
        }
        const analytics = new Analytics({})
        return {
            item,
            onTargetClick: () => {
                analytics.trackEvent({
                    event: 'site merchandising - click',
                    effect: 'campaign click',
                    category: {
                        primaryCategory: 'site merchandising',
                        subCategory: 'campaign'
                    },
                    attributes: {
                        siteMerchandising,
                    },
                })
            },
        }
    }
}

export const getSiteMerchObject = (component) => {
    const { href, rootPosition } = component
    const hrefContainsAnalyticsString = href && href.indexOf('cm_sp=') !== -1
    const campaignInfo = hrefContainsAnalyticsString ? getCampaignEntry(href) : undefined
    if (campaignInfo)
        return {
            placement: campaignInfo.placement,
            position: campaignInfo.position,
            campaignName: campaignInfo.campaignName,
            campaignStartDate: campaignInfo.campaignStartDate,
            modulePosition: rootPosition,
        }
}

export const getCampaignEntry = (link) => {
    const queryString = link.substring(link.indexOf('?') + 1)
    const queryParams = qs.parse(queryString)
    const cmspQueryParam = queryParams.cm_sp || ''

    if (!cmspQueryParam) return
    const params = cmspQueryParam.split('-_-') || []
    const noParam = params.some((p) => !p)
    if (noParam) return
    const [placement, position, campaignName, campaignStartDate] = params
    return {
        placement,
        position,
        campaignName,
        campaignStartDate,
    }
}